module.exports = __webpack_public_path__ + "static/camper2-1fbdcecde196ec5cf925043d74a48a80.svg";